import { render, staticRenderFns } from "./SonsMergeClosedCard.vue?vue&type=template&id=622b10c8&scoped=true&"
import script from "./SonsMergeClosedCard.vue?vue&type=script&lang=js&"
export * from "./SonsMergeClosedCard.vue?vue&type=script&lang=js&"
import style0 from "./SonsMergeClosedCard.vue?vue&type=style&index=0&id=622b10c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b10c8",
  null
  
)

export default component.exports